import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import Pagination from "../../Config/Pagination";
import { API_BASE_CRM_URL } from "../../Config/Config";
import * as XLSX from "xlsx";
import { Button, Input } from "antd";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AddNote from "./AddNote";
import { SearchOutlined } from "@ant-design/icons";

const { Search } = Input;

const Note = () => {
  const location = useLocation();
  const customerId = location.state?.customerId;
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const Type = "Customer";

  console.log(customerId, Type, "typeeeeeeee");
  const [loading, setLoading] = useState(false);

  const [notesList, setNotesList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openNoteDrawer, setOpenNoteDrawer] = useState(false);

  console.log(notesList, "noteslist");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const filteredItems = useMemo(() => {
    const results = notesList.filter(
      (item) =>
        (item.vat && item.vat.toString().includes(searchTerm.toString())) ||
        (item.company &&
          item.company.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.city &&
          item.city.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.phonenumber &&
          item.phonenumber.toLowerCase().includes(searchTerm.toLowerCase())),
    );

    // Reset current page if the search term changes
    setCurrentPage(1);

    return results;
  }, [notesList, searchTerm]);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const formattedHours = hours % 12 || 12;
    const ampm = hours >= 12 ? "PM" : "AM";

    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  };

  const handleExcelDownload = () => {
    if (notesList.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = notesList.map((item) => ({
      Company: item.company,

      "Date Created": formatDate(item.datecreated),
      City: item.city,
      State: item.state,
      Zipcode: item.zip,
      Website: item.website,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    XLSX.utils.book_append_sheet(wb, ws, "notesList");

    // Save the workbook to a file
    XLSX.writeFile(wb, "notesList.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Customers Notes Data",
    });

    // Add data to PDF
    const tableData = [];

    // Add a header row
    const headers = [
      "Company",
      "Phone Number",
      "email",
      "Created Date",
      "City",
      "Website",
    ];
    tableData.push(headers);

    // Add rows
    notesList.forEach((item) => {
      const row = [];
      row.push(
        item.company,
        item.phonenumber,
        item.email,
        formatDate(item.datecreated),
        item.city,
        item.website,
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("CustomersData.pdf");
  };

  const fetchNotesList = async (clientId, type) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}notes/GetNotes?rel_id=${clientId}&rel_type=${type}`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.Status) {
        setNotesList(data.ResultData);
      } else {
        console.error("Fetched data is not an array:", data);
        setNotesList([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotesList(customerId, Type);
  }, [customerId, Type]);

  return (
    <>
      <div className="">
        <div className="d-flex justify-content-between py-1 mb-1 gap-4">
          <div className="col-8">
            <Search
              placeholder="input search text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onSearch={(value) => setSearchTerm(value)}
              enterButton={
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  style={{
                    backgroundColor: "#FF8D1F",
                    borderColor: "#FF8D1F",
                  }}
                />
              }
            />
          </div>
          <div className="col-4 mt-1">
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>

              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm"
                >
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>

              <li>
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                  onClick={() => setOpenNoteDrawer(true)}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row g-2 mb-4">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : notesList && notesList.length > 0 ? (
          notesList.map((item, index) => (
            <div key={index} className="col-xl-4 col-lg-6 col-md-6">
              <div className="card mb-1 rounded-4">
                <div className="card-body">
                  <h6 className=" mb-2">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <i
                          className="fa-solid fa-user me-2"
                          style={{ color: "#1B2850" }}
                        ></i>
                        <span className="fw-semibold">
                          {item?.added_by_name || "N/A"}
                        </span>
                      </div>
                      <div className="d-flex align-items-end justify-content-end">
                        <i
                          className="fa-solid fa-calendar-plus me-2"
                          style={{ color: "#1B2850" }}
                        ></i>
                        <span>{formatDate(item.dateadded)}</span>

                        <i
                          className="fa-solid fa-pen-to-square ms-2"
                          style={{ color: "#1B2850" }}
                        ></i>
                      </div>
                    </div>
                  </h6>

                  <div className="customer-details">
                    <div className="row g-2">
                      <div className="col-12">
                        <div className="d-flex align-items-start">
                          {(() => {
                            const description = item.description || "";

                            // Extract URL from Markdown: [text](url)
                            const markdownMatch = description.match(
                              /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/,
                            );

                            // Get actual URL
                            const mapUrl = markdownMatch
                              ? markdownMatch[2]
                              : description.match(
                                  /https?:\/\/(?:www\.google\.com\/maps|maps\.app\.goo\.gl)[^\s,)]+/,
                                )?.[0];

                            const isMapUrl =
                              mapUrl &&
                              (mapUrl.startsWith(
                                "https://www.google.com/maps",
                              ) ||
                                mapUrl.startsWith("https://maps.app.goo.gl"));

                            if (isMapUrl) {
                              return (
                                <button
                                  type="button"
                                  className="btn btn-link p-0 text-decoration-none"
                                  onClick={() =>
                                    window.open(
                                      mapUrl,
                                      "_blank",
                                      "noopener,noreferrer",
                                    )
                                  }
                                >
                                  <i
                                    className="fa-regular fa-file-lines me-2 mt-1"
                                    style={{ color: "#1B2850" }}
                                  ></i>
                                  <i className="fa-solid fa-location-dot "></i>{" "}
                                </button>
                              );
                            }

                            return (
                              <>
                                <i
                                  className="fa-regular fa-file-lines me-2 mt-1"
                                  style={{ color: "#1B2850" }}
                                ></i>

                                <span
                                  className=""
                                  style={{ maxWidth: "100%" }}
                                  title={description}
                                >
                                  {description || "N/A"}
                                </span>
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center text-muted">No data available</div>
        )}
      </div>

      <Pagination
        itemsPerPage={itemsPerPage}
        totalItems={filteredItems.length}
        paginate={paginate}
        currentPage={currentPage}
      />
      <AddNote
        open={openNoteDrawer}
        onClose={() => setOpenNoteDrawer(false)}
        customerId={customerId}
        addedFrom={userId}
        onSuccess={() => {
          // Call Notes API again here
          fetchNotesList(customerId, Type);
        }}
      />
    </>
  );
};

export default Note;
